import React from 'react'
import { DeepPartial } from 'utility-types'
import {
  Tooltip,
  TooltipTrigger,
  TooltipContent,
} from 'revamp/reusable-components/tooltip/tooltip'
import { AnalystForeCast } from '../types'
import { spCopyRight, spCopyRightSource } from '../constant'
import InStockL2Heading from '../../Pages/InStockDetailPageV2/InL2Heading'
import TargetPrice from './TargetPrice'
import Text from '@/stories/components/Common/NewText'
import { StencilCDNImage } from '@/components/Common/StencilImage'

// eslint-disable-next-line max-lines-per-function
const ForeCast = ({
  target_price,
  compnany_name,
  live_price,
  currencySymbol = '₹',
  showSource = true,
}: DeepPartial<AnalystForeCast> & {
  compnany_name?: string
  live_price?: number | string
  containerClassName?: string
  headingClassName?: string
  currencySymbol?: '$' | '₹'
  showSource?: boolean
}) => {
  // const tpChipName = target_price?.current ? 'Target Price' : ''
  // const nrChipName = revenue?.value_type ? 'Net Revenue' : ''
  // const epChipName = earning_per_share?.value_type ? 'Earning Per Share' : ''
  // const [foreCastChip, setForeCastChip] = useState(
  //   tpChipName || nrChipName || epChipName,
  // )
  if (target_price === null) {
    return null
  }
  // const tpChipName = target_price?.current ? 'Target Price' : ''
  // const nrChipName = revenue?.value_type ? 'Net Revenue' : ''
  // const epChipName = earning_per_share?.value_type ? 'Earning Per Share' : ''
  // const [foreCastChip, setForeCastChip] = useState(
  //   tpChipName || nrChipName || epChipName,
  // )
  // if (target_price === null && revenue === null && earning_per_share === null) {
  //   return null
  // }

  const list = [
    ...(target_price?.upside_per
      ? [
          {
            label: 'What analysts predicted',
            value: `${target_price?.upside_per}%`,
            subValue:
              target_price?.upside_per && target_price.upside_per >= 0
                ? 'UPSIDE'
                : 'DOWNSIDE',
          },
        ]
      : []),
    ...(target_price?.mean
      ? [
          {
            label: 'Target Price',
            value: `${currencySymbol}${target_price?.mean}`,
          },
        ]
      : []),
    ...(live_price ? [{ label: 'Current Price', value: `${live_price}` }] : []),
    ...(target_price?.num_analysts
      ? [
          {
            label: 'Analyzed by',
            value: `${target_price?.num_analysts} Analysts`,
          },
        ]
      : []),
  ]
  const tpjsx = (
    <div className="pt-2">
      <TargetPrice
        list={list}
        {...target_price}
        live_price={live_price}
        data={target_price?.historic_prices ?? []}
        low={target_price?.low}
        high={target_price?.high}
        mean={target_price?.mean}
        growth_per={target_price?.upside_per}
        name={compnany_name}
        currencySymbol={currencySymbol}
      />
    </div>
  )

  // const nrjsx = (
  //   <NetRevenue
  //     sub_title="Excluding Excise Duty and Other Income, represents Net Revenue"
  //     chip_list={[
  //       {
  //         ...revenue?.annually,
  //         heading: `${compnany_name} revenue growth forecast`,
  //         sub_heading: revenue?.annually?.est_text,
  //         title: 'Annual',
  //       },
  //       {
  //         ...revenue?.quarterly,
  //         title: 'Quarterly',
  //         heading: `${compnany_name} revenue growth forecast`,
  //         sub_heading: revenue?.quarterly?.est_text,
  //       },
  //     ]}
  //     {...revenue}
  //     label="Cr"
  //   />
  // )

  // const epjsx = (
  //   <NetRevenue
  //     sub_title="Including amortisation and stock based compensations"
  //     title={`${compnany_name} EPS growth forecast`}
  //     chip_list={[
  //       {
  //         ...earning_per_share?.annually,
  //         heading: `${compnany_name} EPS growth forecast`,
  //         sub_heading: earning_per_share?.annually?.est_text,
  //         title: 'Annual',
  //       },
  //       {
  //         ...earning_per_share?.quarterly,
  //         title: 'Quarterly',
  //         heading: `${compnany_name} EPS growth forecast`,
  //         sub_heading: earning_per_share?.quarterly?.est_text,
  //       },
  //     ]}
  //     {...earning_per_share}
  //   />
  // )

  return (
    <div>
      <div className="flex w-full items-center justify-between">
        {compnany_name && (
          <InStockL2Heading
            heading={`${compnany_name} Share Price Target`}
            subheading={`Get share price movements and forecasts by analysts on ${compnany_name}.`}
          />
        )}
        {showSource && (
          <Tooltip>
            <TooltipTrigger>
              <StencilCDNImage
                src="https://indcdn.indmoney.com/public/images/info_new.png"
                width={18}
                height={18}
                alt="info icon"
                onClick={() => {}}
              />
            </TooltipTrigger>

            <TooltipContent>
              <div className="bg-brand-white border-1 shadow-one w-80 p-2 text-xs">
                {spCopyRight}
              </div>
            </TooltipContent>
          </Tooltip>
        )}
      </div>
      {/* <div className="flex flex-row py-2 pr-2">
        {tpChipName && (
          <Chip selected={true} setChip={() => {}} chip_name={tpChipName} />
        )}
        {/* {nrChipName && (
          <div className="pl-2">
            <Chip
              selected={nrChipName === foreCastChip}
              setChip={setForeCastChip}
              chip_name={nrChipName}
            />
          </div>
        )}
        {epChipName && (
          <div className="pl-2">
            <Chip
              selected={epChipName === foreCastChip}
              setChip={setForeCastChip}
              chip_name={epChipName}
            />
          </div>
        )}
      </div> */}
      {/* Classname hidden is used so that we can crawl the whole data */}

      {tpjsx}
      {/* <div className={classNames({ hidden: nrChipName !== foreCastChip })}>
          {nrjsx}
        </div>
        <div className={classNames({ hidden: epChipName !== foreCastChip })}>
          {epjsx}
        </div> */}
      {showSource && (
        <div className="flex flex-1 justify-end">
          <Text appearance="caption" addClassName=" text-brand-grey-light">
            {spCopyRightSource}
          </Text>
        </div>
      )}
    </div>
  )
}

export default React.memo(ForeCast)
